module.exports = __webpack_public_path__ + "img/2.730850e3.jpg";